import { createContext, useContext } from 'react';
import { useAudioPlayerController } from '@controllers/useAudioPlayerController';

const AudioPlayerContext = createContext(null);

export function AudioPlayerProvider({ children }) {
  const controller = useAudioPlayerController();
  const {
    audioRef,
    handleTimeUpdate,
    handleLoadedMetadata,
    handleEnded
  } = controller;

  return (
    <AudioPlayerContext.Provider value={controller}>
      <audio
        ref={audioRef}
        src={controller.currentEpisode?.url}
        onTimeUpdate={handleTimeUpdate}
        onLoadedMetadata={handleLoadedMetadata}
        onEnded={handleEnded}
        preload="metadata"
      />
      {children}
    </AudioPlayerContext.Provider>
  );
}

export function useAudioPlayer() {
  const context = useContext(AudioPlayerContext);
  if (!context) {
    throw new Error('useAudioPlayer must be used within AudioPlayerProvider');
  }
  return context;
}
